import { Fragment } from 'react';
import { NextPage } from 'next';

import { field, useForm, useSubmit, validate } from '@reckon-web/forms';
import { Flex } from '@reckon-web/flex';
import { Text } from '@reckon-web/text';
import { Button } from '@reckon-web/button';
import { Box } from '@reckon-web/box';
import { Notice } from '@reckon-web/notice';

import { TextField } from '../generic/TextField';

export const VerifyMFAForm: NextPage<{
  onSubmit?: any;
  errorMessage?: string;
  setErrorMessage?: any;
}> = ({ onSubmit, errorMessage, setErrorMessage }) => {
  let mfaForm = field.object({
    code: field.text({
      validate: validate((value) => {
        if (!value.length) return validate.error('Enter the code');
        return value;
      }),
    }),
  });

  let form = useForm(mfaForm);
  const submit = useSubmit(form, async (value) => onSubmit(value));
  return (
    <Fragment>
      <form
        id="mfa-form"
        onChange={() => setErrorMessage('')}
        onSubmit={submit}
      >
        {errorMessage ? (
          <Box paddingBottom="xlarge">
            <Notice tone="critical">
              {errorMessage ? <Text>{errorMessage}</Text> : ''}
            </Notice>
          </Box>
        ) : null}

        <Flex
          direction="column"
          gap="medium"
          alignItems="center"
          padding="xlarge"
        >
          <Box
            paddingX="large"
            paddingY="medium"
            borderRadius="small"
            width={400}
          >
            <TextField
              type="text"
              label="CodeOld"
              {...form.fields.code.props}
            />
            <Box marginTop="medium">
              <Button
                id="login"
                disabled={form.validity !== 'valid'}
                type="submit"
                size="medium"
                block
                label="Confirm"
              />
            </Box>
          </Box>
        </Flex>
      </form>
    </Fragment>
  );
};
